import { GamepadButtonConfig, GamepadButtonAction } from './gamepad-button';
import { defaultAxisDeadzones, defaultAxisExpos, defaultModifierThresholds, Gamepad } from './gamepad';

export class GamepadConfig {
  gamepad: Gamepad;
  actions: GamepadButtonAction[] = [];
  variables: GamepadButtonConfig[] = [];
  /** Profile-level per-axis deadzone, keyed by stick-axis ButtonType. */
  axisDeadzones: { [buttonType: number]: number } = defaultAxisDeadzones();
  /** Profile-level per-axis expo (response curve), keyed by stick-axis ButtonType. */
  axisExpos: { [buttonType: number]: number } = defaultAxisExpos();
  /** Engage point per modifier input, keyed by ButtonType. Profile-level so one trigger cannot engage at two values. */
  modifierThresholds: { [buttonType: number]: number } = defaultModifierThresholds();
  _globalItem = [];
  robotDefinitionId: string;

  static fromJSON(json: any): GamepadConfig {
    const config = new GamepadConfig();

    config.gamepad = json.gamepad && Gamepad.fromJSON(json.gamepad);
    config.actions = json.actions && GamepadButtonAction.fromJSONToList(json.actions);
    config.variables = json.variables && GamepadButtonConfig.fromJSONToList(json.variables);
    // Merge saved values over the defaults so legacy configs without these settings still get sensible values.
    config.axisDeadzones = { ...defaultAxisDeadzones(), ...(json.axisDeadzones || {}) };
    config.axisExpos = { ...defaultAxisExpos(), ...(json.axisExpos || {}) };
    config.modifierThresholds = { ...defaultModifierThresholds(), ...(json.modifierThresholds || {}) };

    return config;
  }

  toJSON(): any {
    return {
      gamepad: this.gamepad?.toJSON(),
      actions: this.actions?.map((x) => x.toJSON()),
      variables: this.variables?.map((x) => x.toJSON()),
      axisDeadzones: this.axisDeadzones,
      axisExpos: this.axisExpos,
      modifierThresholds: this.modifierThresholds,
    };
  }
}
